/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import Logo from 'assets/images/logo.png'
import * as styles from './Auth.scss'

const cx = classNames.bind(styles)

interface IProps {
  children?: React.ReactChild,
  t: Text,
  styleType: string
}

const Auth: React.FC<IProps> = ({ children, t, styleType }) => (
  <section className={cx(styles.CreateAccount, styleType)}>
    <div className={cx('container', styles.container768)}>
      <div className={styles.LoginForm}>
        <div className={styles.Loginlogo}>
          <img src={Logo} alt={t('logoAlt')} />
        </div>
          {children}
      </div>
    </div>
  </section>
)

export default Auth
